import {Paper, Table, TableContainer, TablePagination} from '@mui/material';
import {FC, useState} from 'react';
import {TableToolbar} from './TableToolbar';
import {TableHeadContainer} from './TableHeadContainer';
import {TableBodyContainer} from './TableBody/TableBodyContainer';

interface IDelayed {
  reasonDelays: any[] | null;
}

export const Delayed: FC<IDelayed> = ({reasonDelays}) => {
  const [page, setPage] = useState(0);

  console.log(
    'reasonDelays',
    reasonDelays,
    Array.isArray(reasonDelays) ? reasonDelays.slice(page * 5, page * 5 + 5) : [],
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  return (
    <Paper sx={{flex: 1}}>
      <TableToolbar />
      <TableContainer>
        <Table size="small">
          <TableHeadContainer />
          <TableBodyContainer
            rowsPerPage={5}
            rows={Array.isArray(reasonDelays) ? reasonDelays.slice(page * 5, page * 5 + 5) : []}
            page={page}
          />
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[5]}
          count={Array.isArray(reasonDelays) ? reasonDelays.length : 0}
          page={page}
          rowsPerPage={5}
          onPageChange={handleChangePage}
        />
      </TableContainer>
    </Paper>
  );
};
